export const ApiEndpoints = {

  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },
  
  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },

  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blog/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  },

  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },

  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },

  schemaManagement: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },

  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },

  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },

  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },

  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },

  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view", 
  },

  Dashboard: {
    List: "api/leads-count",
    monthlycount: "api/leads-count-filter"
  },

  caseStudy: {
    caseList: "api/casestudies",
    caseCreate: "api/casestudy/store",
    caseEdit: "api/casestudy/edit/",
    caseUpdate: "api/casestudy/update/",
    caseDelete: "api/casestudy/delete",
  },

  gallery: {
    list: "api/galleries",
    create: "api/gallery/store",
    edit: "api/gallery/edit/",
    update: "api/gallery/update",
    delete: "api/gallery/delete",
    imgDelete:"api/gallery/image/delete"
  },

  press: {
    List: "api/press",
    Create: "api/press/store",
    Edit: "api/press/edit/",
    Update: "api/press/update/",
    Delete: "api/press/delete",
  },

  dynamicPage: {
    List: "api/dynamicpages",
    Create: "api/dynamicpage/store",
    Edit: "api/dynamicpage/edit/",
    Update: "api/dynamicpage/update/",
    Delete: "api/dynamicpage/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },

};
